import { render } from "./DlsAiLogo.vue?vue&type=template&id=4bcc4a4b"
import script from "./DlsAiLogo.vue?vue&type=script&lang=js"
export * from "./DlsAiLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__